import { ChevronRight } from "lucide-react";
import { TeamLogo } from "../../shared/team-logo";
import { DIVISION_LABELS } from "../../../config/constants";

export const TeamResult = ({ team, selected, onSelect, onMouseEnter }) => (
  <div
    onClick={() => onSelect({ ...team, _type: "team" })}
    onMouseEnter={onMouseEnter}
    className={`flex items-center gap-2.5 px-3 py-2 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0 ${
      selected ? "bg-blue-50" : "hover:bg-gray-50"
    }`}
  >
    <div className="w-7 h-7 shrink-0">
      <TeamLogo teamId={team.team_id} teamName={team.team_name} size="w-7 h-7" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-medium text-gray-900 truncate">{team.team_name}</div>
      <div className="text-xs text-gray-500 truncate">
        {[team.conference, DIVISION_LABELS[team.division] ?? team.division]
          .filter(Boolean)
          .join(" · ")}
      </div>
    </div>
    <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
  </div>
);
